// public-path.js
//
// On WordPress: publicPath is baked in at compile time — this file is a no-op
// unless ShipBobConfig.distUrl is explicitly set (e.g. staging overrides).
//
// On HubSpot: the template sets window.ShipBobConfig.distUrl via get_asset_url()
// before this script runs. We override __webpack_public_path__ with that value so
// lazy-loaded chunks resolve from HubSpot's CDN. If distUrl is not set, we leave
// __webpack_public_path__ untouched — webpack's publicPath:'auto' already derived
// the correct base URL from document.currentScript.src.

if (window.ShipBobConfig?.distUrl) {
    __webpack_public_path__ = window.ShipBobConfig.distUrl;

    if (typeof __webpack_require__ !== 'undefined') {
        __webpack_require__.p = window.ShipBobConfig.distUrl;
    }
}
